import { Breadcrumb } from "antd";
import React, { useEffect, useState } from "react";
import breadcrumb from "../../assets/images/breadcrumb.svg";
import notificationIcon from "../../assets/images/notificationIcon.svg";
import mobileMenu from "../../assets/images/mobileMenu.svg";
import Logo from "../../assets/images/PrimecareLogo.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getNotificationCountsHandler } from "../../redux/action/getNotificationsCounts";
import { getItem, setItem } from "../../common/localStorage";
import backBtn from "../../assets/images/backBtn.svg";
import { getPendingMonthsAction } from "../../redux/action/getPendingMonths";
import { getUserProductClaimAction } from "../../redux/action/getUserProductClaim";
import backBtnMobile from "../../assets/images/backBtnMobile.svg";

const MobileSidebar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getAdminId = getItem("adminId");
  const quizDetails = getItem("quizDetails");
  const claimDetails = getItem("claimDetails");
  const setDetails = getItem("setDetails");
  const formDetails = getItem("formDetails");

  const location = useLocation();
  const { state } = location;
  const [mobileSidebar, setMobileSidebar] = useState(false);

  const getNotificationsCountsSelector = useSelector(
    (state) => state?.getNotificationsCounts
  );

  const getAllProductListSelector = useSelector(
    (state) => state?.getProductList
  );

  useEffect(() => {
    if (getAdminId) {
      dispatch(getNotificationCountsHandler({ userId: getAdminId ?? 0 }));
    }
  }, [getAdminId]);

  // useEffect(() => {
  //   if (getNotificationsCountsSelector?.data?.data?.userAgreement === false) {
  //     navigate("/consent");
  //   }
  // }, [getNotificationsCountsSelector]);

  useEffect(() => {
    dispatch(getNotificationCountsHandler({ userId: getAdminId ?? 0 }));
  }, []);

  const backPathsMobile = [
    "/product-info",
    "/dpcextra",
    "/support-request",
    "/manage-notification",
    "/profile-change",
    "/health-quiz",
    "/quiz-list",
    "/quiz-form",
    "/form-info",
    "/form",
  ];
  const isBackPath = backPathsMobile?.includes(location?.pathname);
  const truncate = (text, maxLength = 30) =>
    text?.length > maxLength ? text.slice(0, maxLength) + "..." : text;

  const getHeaderTitle = () => {
    const pathname = location?.pathname;

    switch (pathname) {
      case "/profile-change":
        return t("Profile");
      case "/support-request":
        return t("Support Request");
      case "/manage-notification":
        return t("Manage Notifications");
      case "/product-info":
        return (
          getItem("featureName") ||
          getAllProductListSelector?.data?.data?.products?.[0]?.productName ||
          ""
        );
      case "/dpcextra":
        return state?.itemData?.name || "";
      case "/health-quiz":
        return truncate(state?.item?.claimName) || "";
      case "/quiz-list":
        return truncate(quizDetails?.quizName) || "";
      case "/quiz-form":
        return truncate(setDetails?.setName) || "";
      case "/form-info":
        return truncate(state?.item?.claimName) || "";
      case "/form":
        return truncate(state?.item?.formTitle) || "";
      default:
        return "";
    }
  };

  return (
    <>
      <div className="header">
        <div className="headerFlex">
          {/* <div
            className="mobileShow cursor-pointer"
            onClick={() => setMobileSidebar(true)}
          >
            <img src={mobileMenu} alt="" />
          </div> */}
          <div
            className="mobileShow cursor-pointer"
            onClick={
              isBackPath ? () => navigate(-1) : () => setMobileSidebar(true)
            }
          >
            <img src={isBackPath ? backBtnMobile : mobileMenu} alt="" />
          </div>
          <div className="breadcrumbAboslute justify-lg-center d-flex gap-10 align-center">
            {[
              "/health-quiz",
              "/quiz-list",
              "/quiz-form",
              "/form-info",
              "/form",
              "/profile-change",
              "/manage-notification",
              "/support-request",
              "/dpcextra",
              "/product-info",
            ].includes(location?.pathname) && (
              <img
                src={backBtn}
                onClick={() => {
                  if (location?.pathname === "/health-quiz") {
                    navigate("/claims");
                  } else {
                    navigate(-1);
                  }
                }}
                className="cursor-pointer backBtn"
                alt=""
              />
            )}
            {[
              "/profile-change",
              "/product-info",
              "/dpcextra",
              "/manage-notification",
              "/support-request",
              "/health-quiz",
              "/quiz-list",
              "/quiz-form",
              "/form-info",
              "/form",
            ].includes(location?.pathname) ? (
              <div>
                <h2 className="pageName fs-20 fw-600 mb-10">
                  {getHeaderTitle()}
                </h2>
                <Breadcrumb
                  className="breadcrumb cursor-pointer"
                  separator={
                    <span>
                      <img src={breadcrumb} alt="" />
                    </span>
                  }
                  items={[
                    {
                      title: [
                        "/product-info",
                        "/dpcextra",
                        "/health-quiz",
                        "/quiz-list",
                        "/quiz-form",
                        "/form-info",
                        "/form",
                      ].includes(location?.pathname)
                        ? t("Products")
                        : t("Settings"),
                      onClick: [
                        "/profile-change",
                        "/manage-notification",
                        "/support-request",
                        "/product-info",
                        "/health-quiz",
                        "/quiz-form",
                        "/form-info",
                        "/form",
                        "/quiz-list",
                      ].includes(location?.pathname)
                        ? () =>
                            navigate(
                              location?.pathname === "/product-info" ||
                                location?.pathname === "/health-quiz" ||
                                location?.pathname === "/quiz-form" ||
                                location?.pathname === "/form-info" ||
                                location?.pathname === "/form"
                                ? "/dashboard"
                                : "/settings"
                            )
                        : undefined,
                    },
                    {
                      title:
                        location?.pathname === "/form"
                          ? truncate(claimDetails?.claimName)
                          : location?.pathname === "/health-quiz" ||
                            location?.pathname === "/quiz-list"
                          ? undefined
                          : undefined,
                      onClick:
                        location?.pathname === "/form"
                          ? () =>
                              navigate("/form-info", {
                                state: state,
                              })
                          : undefined,
                    },

                    {
                      title:
                        location?.pathname === "/product-info" ||
                        location?.pathname === "/dpcextra"
                          ? getItem("featureName")
                          : undefined,
                      onClick:
                        location?.pathname === "/dpcextra" &&
                        getItem("featureName")
                          ? () =>
                              navigate("/product-info", {
                                state: state?.stateDashboard,
                              })
                          : undefined,
                    },
                    {
                      title:
                        location?.pathname === "/dpcextra"
                          ? getItem("innerFeature")
                          : location?.pathname === "/quiz-list" ||
                            location?.pathname === "/quiz-form"
                          ? truncate(claimDetails?.claimName)
                          : undefined,
                      onClick:
                        location?.pathname === "/quiz-list"
                          ? () => navigate("/health-quiz", { state: state })
                          : undefined,
                    },
                    {
                      title:
                        location?.pathname === "/quiz-form"
                          ? truncate(quizDetails?.quizName)
                          : undefined,
                      onClick:
                        location?.pathname === "/quiz-form"
                          ? () =>
                              navigate("/quiz-list", { state: state?.state })
                          : undefined,
                    },
                    {
                      title:
                        location?.pathname === "/manage-notification"
                          ? t("Manage Notifications")
                          : location?.pathname === "/product-info" ||
                            location?.pathname === "/dpcextra"
                          ? getItem("productName") || t("Profile")
                          : location?.pathname === "/health-quiz"
                          ? truncate(claimDetails?.claimName)
                          : location?.pathname === "/support-request"
                          ? t("Support Request")
                          : location?.pathname === "/quiz-list"
                          ?truncate(quizDetails?.quizName)
                          : location?.pathname === "/quiz-form"
                          ? truncate(setDetails?.setName)
                          : location?.pathname === "/form-info"
                          ? truncate(claimDetails?.claimName)
                          : location?.pathname === "/form"
                          ? truncate(formDetails?.item?.formTitle)
                          : t("Profile"),
                    },
                  ]}
                />
              </div>
            ) : (
              <div>
                <h2 className="pageName fs-20 fw-600 mb-10">
       
                  {location?.pathname === "/dashboard"
                    ? (() => {
                        const stored = getItem("productName");
                        const firstProduct =
                          getAllProductListSelector?.data?.data?.products?.[0]
                            ?.productName;
                        if (!stored && firstProduct) {
                          setItem("productName", firstProduct);
                          return firstProduct;
                        }
                        return stored;
                      })()
                    : t(
                        location?.pathname
                          ?.split("/")
                          .filter(Boolean)
                          .map(
                            (part) =>
                              part.charAt(0).toUpperCase() + part.slice(1)
                          )
                          .join(" / ")
                      )}
                </h2>
              </div>
            )}
            
          </div>

          <div
            className="cursor-pointer badge"
            onClick={() => navigate("/notification")}
          >
            <img src={notificationIcon} alt="" />
            <sup>
              {getNotificationsCountsSelector?.data?.data?.notificationCount}
            </sup>
          </div>
        </div>
      </div>
      <div
        className={`mobileSidebar mobileShow  ${
          mobileSidebar === true ? "appear" : ""
        }`}
      >
        <div className="mx-280">
          <div className="headerLogoImage">
            <img src={Logo} alt="" />
          </div>
          <div className="p-20">
            <div className="tgb fw-600 mb-20 fs-18">{t("My Products")}</div>
            {getAllProductListSelector?.data?.data?.products?.map(
              (item, index) => {
                return (
                  <h3
                    className={`productList cursor-pointer ${
                      getAllProductListSelector?.data?.data?.products?.length >
                        0 &&
                      (getItem("productName") === item?.productName ||
                        (!getItem("productName") &&
                          getAllProductListSelector?.data?.data?.products?.[0]
                            ?.productName === item?.productName))
                        ? "activated"
                        : ""
                    }`}
                    onClick={() => {
                      navigate("/dashboard", { state: item });
                      setItem("groupId", item?.groupId);
                      setItem("productCode", item?.productCode);
                      setItem("productName", item?.productName);
                      setItem("isClaimEnable", item?.isClaimEnable);
                      setMobileSidebar(false);
                      dispatch(
                        getPendingMonthsAction.getPendingMonthsInfoReset()
                      );
                      dispatch(
                        getUserProductClaimAction.getUserProductClaimInfoReset()
                      );
                    }}
                    key={index}
                  >
                    {item?.productName}
                  </h3>
                );
              }
            )}
          </div>
        </div>
      </div>
      {mobileSidebar === true ? (
        <>
          <div
            className="mobileOverlay mobileShow cursor-pointer"
            onClick={() => setMobileSidebar(false)}
          ></div>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default MobileSidebar;
